export const UPDATE_USER_DETAIL = 'scenes/ClientDetail/update_user_detail'
export const UPDATE_CLIENT_DETAIL = 'scenes/ClientDetail/update_client_detail'
export const STATE_CHANGED = 'scenes/ClientDetail/state_changed'
export const LOCATION_CHANGED = 'scenes/ClientDetail/location_changed'
export const CLIENT_DATA_CHANGED = 'scenes/ClientDetail/client_data_changed'
export const VEHICLES_FETCHED = 'scenes/ClientDetail/vehicles_fetched'
export const LOGS_FETCHED = 'scenes/ClientDetail/logs_fetched'
export const NOTIFICATIONS_FETCHED = 'scenes/ClientDetail/notifications_fetched'




// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/constants.js